import { RequestCreationSuccess } from "@features/cx/shared/components/RequestCreationSuccess";
import { useLocation, useNavigate } from "react-router-dom";

function ServiceRequestSuccessPage() {
  const navigate = useNavigate();
  // The state contains the merged data from your navigation
  const { formData, ...apiResponse } = useLocation().state || {};

  const requestData = {
    ...apiResponse,
    formData: formData,
  };
  if (!requestData) {
    return <div>No request data found</div>;
  }

  console.log("requestData requestData", requestData);

  return (
    <RequestCreationSuccess
      requestData={requestData}
      requestType="service"
      onReturnToDashboard={() => navigate("/cx/services")}
      onAddNewRequest={() => navigate("/cx/services/create/#customer-info")}
    />
  );
}

export default ServiceRequestSuccessPage;
